import { render, staticRenderFns } from "./placeholder-messages-not-generated.vue?vue&type=template&id=2a69fea9"
import script from "./placeholder-messages-not-generated.vue?vue&type=script&lang=js"
export * from "./placeholder-messages-not-generated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a69fea9')) {
      api.createRecord('2a69fea9', component.options)
    } else {
      api.reload('2a69fea9', component.options)
    }
    module.hot.accept("./placeholder-messages-not-generated.vue?vue&type=template&id=2a69fea9", function () {
      api.rerender('2a69fea9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/campaign-scheduling/placeholder-messages-not-generated.vue"
export default component.exports